module.exports = __webpack_public_path__ + "img/color7_on.3135b7f1.png";